import type { PartTransaction, PartTransactionBase } from "../../types";
import { createBaseService } from "./baseService";

const base = createBaseService<PartTransaction, PartTransactionBase>({
  tableName: "part_transactions",
  viewName: "part_transactions_enriched",
  computedColumns: ["partName"],
  searchColumns: ["part_name", "notes"],
});

export class PartTransactionService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static update = base.update;
  static delete = base.delete;
}
